import React, { ReactNode } from 'react';
import AvConfirmDialog, { ButtonConfiguration } from '@components/AvConfirmDialog';
import CrossAppHeader from '@components/CrossAppHeader';
import { Box } from '@mui/material';

interface CrossAppChangeAvDialogProps {
  title?: ReactNode;
  titleVariant?: 'error' | 'warning';
  isOpen: boolean;
  onClose: () => void;
  body?: ReactNode;
  onConfirm?: () => void;
}

export const appChangeWarningBody = (newLine = false) => {
  if (newLine) {
    return <Box sx={{ fontWeight: 600 }}>This change could affect several applications in this account.</Box>;
  }
  return <span style={{ fontWeight: 600 }}>This change could affect several applications in this account.</span>;
};

const CrossAppChangeDialog: React.FC<CrossAppChangeAvDialogProps> = ({
  title = 'Save Changes?',
  titleVariant,
  isOpen,
  onClose,
  body,
  onConfirm = () => {},
}) => {
  const confirmButton: ButtonConfiguration = {
    onClick: onConfirm,
    color: 'warning',
    text: 'Confirm',
  };
  const closeButton = { onClick: onClose };
  const defaultBody = (
    <div>
      {appChangeWarningBody(true)}
      <div>Are you sure you want to proceed? </div>
    </div>
  );

  return (
    <AvConfirmDialog
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      titleVariant={titleVariant}
      body={body || defaultBody}
      confirmButton={confirmButton}
      closeButton={closeButton}
      header={<CrossAppHeader />}
    />
  );
};

export default CrossAppChangeDialog;
